
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Plus, RefreshCw } from "lucide-react";

interface PrintableItemsHeaderProps {
  loading: boolean;
  onRefresh: () => void;
  dialogOpen: boolean;
  onDialogOpenChange: (open: boolean) => void;
}

const PrintableItemsHeader = ({
  loading,
  onRefresh,
  dialogOpen,
  onDialogOpenChange,
}: PrintableItemsHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h3 className="text-2xl font-bold text-slate-800">Printable Items</h3>
        <p className="text-slate-600">Manage printable items and downloads</p>
      </div>
      <div className="flex gap-2">
        <Button onClick={onRefresh} disabled={loading} variant="outline">
          <RefreshCw className={`w-4 h-4 mr-2 ${loading ? 'animate-spin' : ''}`} />
          Refresh
        </Button>
        <Dialog open={dialogOpen} onOpenChange={onDialogOpenChange}>
          <DialogTrigger asChild>
            <Button className="bg-blue-600 hover:bg-blue-700">
              <Plus className="w-4 h-4 mr-2" />
              Add Item
            </Button>
          </DialogTrigger>
        </Dialog>
      </div>
    </div>
  );
};

export default PrintableItemsHeader;
